import * as React from 'react';
const SvgPathSplitRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.01 14.99c.77 0 1.51-.3 2.06-.82l6.94 4.01c.04.73.35 1.42.87 1.94.56.56 1.33.88 2.12.88s1.56-.32 2.12-.88S21 18.79 21 18s-.32-1.56-.88-2.12S18.79 15 18 15s-1.56.32-2.12.88c-.1.1-.2.22-.29.33l-6.62-3.82Q9 12.195 9 12v-.02l6.81-3.93c.02.02.04.05.07.07.56.56 1.33.88 2.12.88s1.56-.32 2.12-.88S21 6.79 21 6s-.32-1.56-.88-2.12S18.79 3 18 3s-1.56.32-2.12.88S15 5.21 15 6v.21l-6.7 3.87c-.06-.07-.12-.14-.18-.2C7.56 9.32 6.79 9 6 9s-1.56.32-2.12.88S3 11.21 3 12s.32 1.56.88 2.12S5.21 15 6 15zm0-2c-.27 0-.52-.11-.71-.29a1 1 0 0 1-.29-.71c0-.27.11-.52.29-.71a1 1 0 0 1 .71-.29c.27 0 .52.11.71.29.19.19.29.44.29.71s-.11.52-.29.71a1 1 0 0 1-.71.29m12-6c-.27 0-.52-.11-.71-.29a1 1 0 0 1-.29-.71c0-.27.11-.52.29-.71a1 1 0 0 1 .71-.29c.27 0 .52.11.71.29.19.19.29.44.29.71s-.11.52-.29.71a1 1 0 0 1-.71.29m0 12c-.27 0-.52-.11-.71-.29a1 1 0 0 1-.29-.71c0-.27.11-.52.29-.71a1 1 0 0 1 .71-.29c.27 0 .52.11.71.29.19.19.29.44.29.71s-.11.52-.29.71a1 1 0 0 1-.71.29"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPathSplitRight;
